import { createRequest } from '@/utils/request'

const request = createRequest({})
export async function IGetData(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/dvl/getDvlList.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IGetAllData(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/dvl/getDvlAllList.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}

export async function IGetResult(params: any) {
  let getUrl = '/nddt/portal/nongdi-data-api/ndpf/portal/api/dvl/getDvlDetail.do?'
  Object.entries(params).forEach(([key, value]) => {
    getUrl += `${key}=${value}&`
  })
  if (getUrl.endsWith('&')) {
    getUrl = getUrl.slice(0, -1)
  }
  return request.get(getUrl)
}
